<template>
  <div
    class="indexssss"
    v-loading="loading"
    :element-loading-text="'Upload: ' + Number(p * 100) + '%'"
  >
    <div class="stepbox" v-show="step === 1">
      <div class="formBox">
        <div class="right">
          <el-upload
            class="upload-demo"
            drag
            action="1"
            :http-request="setFile"
            :limit="10"
            :on-remove="remove"
            :on-change="handleChange"
            accept=".pdf,.docx,.doc"
            ref="upload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <div>
            <el-radio v-model="radio" label="1">我自己的简历</el-radio>
            <el-radio v-model="radio" label="2">我推荐的候选人的简历</el-radio>
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="submit1">下一步</el-button>
      </div>
    </div>
    <div class="stepbox" v-show="step === 2">
      <div class="bt">候选人信息确认</div>
      <el-form :model="dataObject">
        <el-form-item label="*姓名" :label-width="formLabelWidth">
          <el-input v-model="dataObject.name"></el-input>
        </el-form-item>
        <el-form-item label="*手机号码" :label-width="formLabelWidth">
          <el-input v-model="dataObject.phone"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" :label-width="formLabelWidth">
          <el-input v-model="dataObject.email"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth">
          <el-radio-group v-model="dataObject.sex" size="mini">
            <el-radio label="男" border>男</el-radio>
            <el-radio label="女" border>女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学历" :label-width="formLabelWidth">
          <el-radio-group v-model="dataObject.education" size="mini">
            <el-radio label="博士" border>博士</el-radio>
            <el-radio label="硕士" border>硕士</el-radio>
            <el-radio label="本科" border>本科</el-radio>
            <el-radio label="大专" border>大专</el-radio>
            <el-radio label="高中" border>高中</el-radio>
            <el-radio label="中专/中技" border>中专/中技</el-radio>
            <el-radio label="初中及以下" border>初中及以下</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" :label-width="formLabelWidth">
          <el-input v-model="dataObject.age"></el-input>
        </el-form-item>
        <el-form-item label="工作经验（年）" :label-width="formLabelWidth">
          <el-input v-model="dataObject.workingLifeMax"></el-input>
        </el-form-item>
        <el-form-item label="最近公司" :label-width="formLabelWidth">
          <el-input v-model="dataObject.nowCompany"></el-input>
        </el-form-item>
        <el-form-item label="最近职位" :label-width="formLabelWidth">
          <el-input v-model="dataObject.nowJob"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button @click="goback">返回</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import Config from "../config/index";
import OSS from "ali-oss";
import qs from "qs";

let client = new OSS({
  region: "oss-cn-beijing",
  accessKeySecret: "mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5", // AccessKeySecret 去你的阿里云上控制台上找
  accessKeyId: "LTAIvBaMapD5qPW9", // AccessKeyId 去你的阿里云上控制台上找
  bucket: "linkedln",
  endpoint: "images.qilinpin.cn",
  cname: true,
  secure: true,
});

// client.useBucket('linkedln')

export default {
  name: "upload",
  components: {},
  data() {
    return {
      formLabelWidth: "120px",
      name: "",
      phone: "",
      email: "",
      id: "",
      file: false,
      fileUrl: "",
      radio: "2",
      p: "",
      loading: false,
      loadT: "",
      status: "",
      ticket: "",
      qrUrl: "",
      loginState: false,
      nowCompany: "",
      nowJob: "",
      avater: "",
      nickname: "",
      posinfo: false,
      step: 1,
      dataObject: false,
    };
  },
  created: function () {},
  mounted: function () {
    this.id = this.$route.params.id
  },
  methods: {
    handleChange: function (file, fileList) {
      
;
      if (fileList.length > 1) {
        fileList[0] = fileList[1];
        fileList.splice(1, 1);
      }
    },
    remove: function () {
      this.file = false;
    },
    setFile: function (res) {
      
;
      let name = res.file.name.substring(0, Number(res.file.name.length) - 4);
      this.name = name;
      this.file = res.file;
    },
    uplaod1: function (res) {
      let that = this;
      let file = this.file;
      let formData = new FormData();
      this.loading = true;
      formData.append("file", file);
      formData.append("user", localStorage.getItem("token"));
      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data;boundary=" + new Date().getTime(),
        },
      };

      axios
        .post("https://api.qilinpin.cn/gptapi/api/uploadRes", formData, config)
        .then(function (response) {
          
;
          that.loading = false;
          if (response.data.msg.basic_info) {
            that.posinfo = response.data.msg;
            that.setDataobject();
            console.log(response);
          } else {
            that.$message.error(response.data.msg);
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uplaod: function (res) {
      let that = this
      if (that.dataObject.name === "" || that.dataObject.name === undefined) {
        that.$message.warning("请确认候选人姓名");
        return false;
      }

      if (that.dataObject.phone === "" || that.dataObject.phone === undefined) {
        that.$message.warning("请确认候选人手机号");
        return false;
      }

      this.loading = true;
      let str = this.random_string(32);
      
;

      let dontindex = this.file.name.indexOf(".");
      let dontstr = this.file.name.slice(dontindex);

      client
        .multipartUpload("uploadPdf/" + str + "" + dontstr, this.file, {
          progress: function (p) {
            that.loading = true;
            console.log("Progress: " + p);
            that.p = p;
          },
        })
        .then((res) => {
          console.log(res);
          that.loading = false;
          that.fileUrl = "https://images.qilinpin.cn/" + res.name;
          that.post();
        })
        .catch((err) => {
          that.loading = false;
          console.log(err);
        });
    },
    random_string: function (len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    random_number: function (len) {
      len = len || 32;
      var chars = "123456789";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    post: function () {
      let that = this;
      
;
      let url = Config.path + "/api/candidate/pc/upResume";
      let data = that.dataObject;
      data.path = this.fileUrl;
      data.flag = this.radio;
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then(function (response) {
          console.log(response);
          if (response.data.success === "1") {
            that.loading = false;
            that.name = "";
            that.phone = "";
            that.email = "";
            that.file = false;
            that.fileUrl = "";
            that.radio = "1";
            that.$refs.upload.clearFiles();
            
;
            that.uploadNodeInfo(response.data.content.id);
          } else {
            that.loading = false;
            that.$message({
              message: response.data.message,
              type: "warning",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;

          // eslint-disable-next-line
          console.log(error);
        });
    },
    uploadNodeInfo: function (id) {
      
;
      let that = this;
      this.loading = true;

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("pkkid", localStorage.getItem("token"));
      urlencoded.append("hashid", that.posinfo.hashid);
      urlencoded.append("pkkresid", id);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      fetch("https://api.qilinpin.cn/gptapi/api/linkpkk", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false;
          let res = JSON.parse(result).msg;
          that.$message({
            message: "简历上传成功",
            type: "success",
          });
          if (that.id === "" || that.id === undefined || that.id === null) {
            that.$router.back(-1);
          } else {
            that.postRes(id)
          }
          
        })
        .catch((error) => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
          console.log("error", error);
        });
    },

    postRes: function (sid) {
            let that = this
            that.loading = true
            this.$confirm('确认投递该简历？')
                .then(_ => {
                    let data = {
                        resumeId: sid,
                        jobid: that.id
                    }
                    axios({
                        method: 'POST',
                        url: Config.path + '/api/candidate/resumeDeliver',
                        headers: {
                            token: localStorage.getItem('token'),
                            'content-type': 'application/json',
                        },
                        data: data,
                    })
                        .then((res) => {
                            that.loading = false
                            that.$router.back(-1);
                        })
                        .catch((err) => {
                            that.loading = false
                            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                        })
                })
                .catch(_ => {
                  that.$router.back(-1);
                 });
        },

    submit: function () {
      if (this.file) {
        this.uplaod();
      } else {
        this.$message({
          message: "请先选择简历文件",
          type: "warning",
        });
      }
    },
    submit1: function () {
      if (this.file) {
        this.uplaod1();
      } else {
        this.$message({
          message: "请先选择简历文件",
          type: "warning",
        });
      }
    },
    setDataobject: function () {
      let data = {};
      if (
        this.posinfo.basic_info.name &&
        this.posinfo.basic_info.name !== "" &&
        this.posinfo.basic_info.name !== null &&
        this.posinfo.basic_info.name !== undefined
      ) {
        data.name = this.posinfo.basic_info.name;
      } else {
        data.name = "";
      }
      if (
        this.posinfo.contact_info.phone_number &&
        this.posinfo.contact_info.phone_number !== "" &&
        this.posinfo.contact_info.phone_number !== null &&
        this.posinfo.contact_info.phone_number !== undefined
      ) {
        data.phone = this.posinfo.contact_info.phone_number;
      } else {
        data.phone = "";
      }
      if (
        this.posinfo.contact_info.email &&
        this.posinfo.contact_info.email !== "" &&
        this.posinfo.contact_info.email !== null &&
        this.posinfo.contact_info.email !== undefined
      ) {
        data.email = this.posinfo.contact_info.email;
      } else {
        data.email = "";
      }
      if (
        this.posinfo.basic_info.gender &&
        this.posinfo.basic_info.gender !== "" &&
        this.posinfo.basic_info.gender !== null &&
        this.posinfo.basic_info.gender !== undefined
      ) {
        data.sex = this.posinfo.basic_info.gender;
      } else {
        data.sex = "";
      }
      if (
        this.posinfo.basic_info.degree &&
        this.posinfo.basic_info.degree !== "" &&
        this.posinfo.basic_info.degree !== null &&
        this.posinfo.basic_info.degree !== undefined
      ) {
        data.education = this.posinfo.basic_info.degree;
      } else {
        data.education = "";
      }
      if (
        this.posinfo.basic_info.age &&
        this.posinfo.basic_info.age !== "" &&
        this.posinfo.basic_info.age !== null &&
        this.posinfo.basic_info.age !== undefined
      ) {
        data.age = this.posinfo.basic_info.age;
      } else {
        data.age = "";
      }
      
;
      if (
        this.posinfo.basic_info.num_work_experience &&
        this.posinfo.basic_info.num_work_experience !== "" &&
        this.posinfo.basic_info.num_work_experience !== null &&
        this.posinfo.basic_info.num_work_experience !== undefined
      ) {
        data.workingLifeMax = this.posinfo.basic_info.num_work_experience;
      } else {
        data.workingLifeMax = "";
      }
      if (this.posinfo.work_experience.length > 0) {
        data.nowCompany = this.posinfo.work_experience[0].company_name;
        data.nowJob = this.posinfo.work_experience[0].job_title;
      } else {
        data.nowCompany = "";
        data.nowJob = "";
      }
      this.step = 2;
      this.dataObject = data;
    },
    goback: function () {
      this.step = 1;
      this.dataObject = false;
      this.loading = false;
      this.name = "";
      this.phone = "";
      this.email = "";
      this.file = false;
      this.fileUrl = "";
      this.radio = "1";
      this.$refs.upload.clearFiles();
    },
  },
};
</script>

<style scoped>
.indexssss {
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.8);
  align-items: center;
  width: 100vw;
  justify-content: center;
  background-size: cover;
  background-attachment: fixed;
  flex: 1;
}

.stepbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.formBox {
  min-width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.formBox > div {
  margin-top: 20px;
  width: 500px;
}

.formBox > .left {
  border-right: 2px solid #eaeaea;
}

.formBox > .right {
  padding: 20px 50px;
  box-sizing: border-box;
}

.formBox .demo-input-suffix {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 50px;
}

.formBox .demo-input-suffix > span {
  padding: 10px;
  color: darkgray;
  width: 150px;
}

.formBox .demo-input-suffix .el-input {
  /* background-color: #000; */
}

/* .formBox .demo-input-suffix .el-input>input{
    background-color: #000;
} */

.formBox button {
  margin-top: 60px;
}

.loginBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  margin-top: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qrcont {
  width: 300px;
  height: 300px;
  background-size: 100%, 100%;
}

.qrtext {
  color: #ffffff;
  padding-top: 20px;
  text-align: center;
}

.userInfo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 20px;
  color: darkgray;
}

.userInfo img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-right: 10px;
}

.btn {
  margin-top: 50px;
}

.bt {
  width: 90%;
  font-size: 20px;
  font-weight: bold;
  padding-left: 20px;
  height: 26px;
  line-height: 26px;
  border-left: 5px solid #5dc1cf;
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
<style>
.formBox .demo-input-suffix .el-input > input {
  border: none;
  background-color: #f8f8f8;
}

.jlzxbox {
  width: 90vw;
  height: 70vh;
  margin: 20px auto;
}
</style>
